var map = {
	"./blog.yml": 182,
	"./cloud.yml": 183,
	"./color.yml": 184,
	"./country.yml": 185,
	"./dio.yml": 186,
	"./doc.yml": 187,
	"./emoji.yml": 188,
	"./git.yml": 189,
	"./icon.yml": 190,
	"./license.yml": 191,
	"./link.yml": 192,
	"./metrics.yml": 193,
	"./people.yml": 194,
	"./soft.yml": 195,
	"./src.yml": 196,
	"./status.yml": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 181;